import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs = () => {
  return (
    <div className="nav-bar__tabs">
      {/* <NavBarTab path="/live" label="live search" /> */}
      <NavBarTab path="/" label="search" />
      <NavBarTab path="/about" label="about" />
      {/* <NavBarTab path="/favorites" label="favorites" /> */}
    </div>
  );
};
